// packages/plugins/src/components/index.ts
import { default as default2 } from "./plugin-area/index.mjs";
import { usePluginContext, withPluginContext } from "./plugin-context/index.mjs";
export {
  default2 as PluginArea,
  usePluginContext,
  withPluginContext
};
//# sourceMappingURL=index.mjs.map
